/** Canonical author/expertise entity for blog content — wired into BlogPosting
 *  JSON-LD and the visible author block so Google can attribute E-E-A-T to a
 *  real, identifiable business operator. */
export const WOODSEER_AUTHOR = {
  name: "Woodseer Autos Workshop Team",
  role: "DVSA-authorised MOT testers & mechanics",
  bio:
    "The Woodseer Autos workshop team are DVSA-authorised MOT testers and qualified mechanics with hands-on experience across all MOT classes (1, 2, 3, 4, 5 & 7). Articles are written and reviewed by the same technicians who carry out the work in our East London workshop.",
  credentials: [
    "DVSA-authorised MOT Testing Station — VTS V106376",
    "MOT classes 1, 2, 3, 4, 5 & 7",
    "Independent garage operating from 14 Copenhagen Place, London E14 7DF",
  ],
  url: "https://woodseerautos.co.uk/official-business-information",
  sameAs: [
    "https://www.instagram.com/woodseerautos/",
    "https://linktr.ee/woodseerautos",
  ],
} as const;
